import {  AnalyticsRounded, Dashboard, KeyboardOptionKey, MiscellaneousServicesOutlined, Reviews, Store } from "@mui/icons-material";
import { Divider, Grid, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Sidebar() {

    var loc = useLocation();
    var navi = useNavigate();

    const slug = loc.pathname.split("/")[2];

    const [paths, setpaths] = useState([
        { Name: 'Dashboard', icon: <Dashboard sx={{ fontSize: 20 }} />, Path: 'Dashboard' },
        { Name: 'Analytics', icon: <AnalyticsRounded sx={{ fontSize: 20 }} />, Path: 'Options' },
        { Name: 'Gallery', icon: <Store sx={{ fontSize: 20 }} />, Path: 'Gallery' },
        { Name: 'Services', icon: <MiscellaneousServicesOutlined sx={{ fontSize: 20 }} />, Path: 'Services' },
        { Name: 'Reviews', icon: <Reviews sx={{ fontSize: 20 }} />, Path: 'Reviews' },
        { Name: 'Business Details', icon: <KeyboardOptionKey sx={{ fontSize: 20 }} />, Path: 'details' },
        { Name: 'Team', icon: <KeyboardOptionKey sx={{ fontSize: 20 }} />, Path: 'Team' },
        { Name: 'Options', icon: <KeyboardOptionKey sx={{ fontSize: 20 }} />, Path: 'Options' },
        { Name: 'Settings', icon: <KeyboardOptionKey sx={{ fontSize: 20 }} />, Path: 'Options' },
    ]);

    const uuid = localStorage.getItem('uuid');
    const name = localStorage.getItem('salonName');

    return (
        <>

            <Grid bgcolor={'#0F1536'} size={{ lg: 2.4 }} textAlign={'center'} height={'100vh'} color={'white'}>
                <Typography variant="h4" className="mt-4">BookYourSalon</Typography>
                {/* <hr className="text-black" /> */}
                {/* <Divider /> */}
                {/* <br /> */}
                {/* <br /> */}
                {/* <br /> */}
                {/* <Link className="admin-list">Dashboard</Link> */}
                {/* <List> */}
                {/* <ListItemButton> */}
                {/* <ListItemText title="Dashboard" className="text-black" /> */}
                {/* </ListItemButton> */}
                {/* </List> */}
                <Grid px={4} mt={5}>
                    {paths.map((row) => (
                        row.Path == loc.pathname ? (

                            <Grid className='admin-list-item-selected bg-dark mt-3 shadow'>
                                <Grid className="bg-admin-selected">
                                    {row.icon}
                                </Grid>
                                <Typography variant="h6" className="ms-2">{row.Name}</Typography>
                            </Grid>
                        ) : (
                            <Grid onClick={() => navi(`/Salon/${slug}/${row.Path}`)} className='admin-list-item mt-3'>
                                <Grid className="bg-admin shadow">
                                    {row.icon}
                                </Grid>
                                <Typography variant="h6" className="ms-2">{row.Name}</Typography>
                            </Grid>
                        )
                    ))}
                    {/* <Grid className='admin-list-item'>
                        <Grid className="bg-admin shadow">
                            <Store sx={{ fontSize: 21 }} />
                        </Grid>
                        <Typography variant="h6" className="ms-2">Shops</Typography>
                    </Grid> */}
                    {/* <Grid className='admin-list-item'>
                        <Grid className="bg-admin shadow">
                            <Dashboard sx={{fontSize:20}} />
                        </Grid>
                        <Typography variant="h6" className="ms-2">Dashboard</Typography>
                    </Grid> */}

                </Grid>
            </Grid>

        </>
    )


}